import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'camelCaseToTitleCase'
})
export class CamelCaseToTitleCase implements PipeTransform {
  transform(value: string) {
    return value.replace(/([A-Z])/g, ' $1').trim();
  }
}
